import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {countryStates_template} from "./countryStates_template";

declare var ko: any;

export class candidate_template extends vnTemplate {
    public countryGroups: countryStates_template;

    protected getTemplateHtml(): string {

        return `
            <div class="form-header">
                <h3 class="form-title icon i-user">Sign Up</h3>
            </div>
            <div class="form-body">
                <div class="form-group">
                    <label for="firstName" class="form-label">First Name</label>
                    <input id="firstName" data-bind="value: firstName" type="text" class="input-text" disabled>
                 </div>
                 <div class="form-group">
                    <label for="lastName" class="form-label">Last Name</label>
                    <input id="lastName" data-bind="value: lastName" type="text" class="input-text" disabled>
                 </div>
                <div class="form-group">
                    <label for="loginName" class="form-label">User Name</label>
                    <input id="loginName" data-bind="value: loginName" type="text" class="input-text" disabled>
                </div>
                <div class="form-group">
                    <label for="email" class="form-label">Email</label>
                    <input id="email" data-bind="value: email" type="email" class="input-text" disabled>
                </div>
                <div class="form-group">
                    <label for="country-select" class="form-label">Country of Residence</label>
                    <select id="country-select" class="input-text" name="country" data-bind="
                        optionsCaption: 'Select',
                        options: countries,
                        optionsValue: 'id',
                        optionsText: 'name',
                        value: idCountry,
                        event: {change: onChangeCountry}

                        "> 
                    </select>
                </div>
                ${ this.countryGroups.getHtmlBuild() }
                <div class="form-group">
                    <label for="" class="form-label">Password</label>
                    <input id="password" data-bind="value: password" type="password" class="input-pass">
                </div>
                <div class="form-group">
                    <label for="passwordConfirmation" class="form-label">Password Confirmation</label>
                    <input id="passwordConfirmation" data-bind="value: passwordConfirmation" type="password" class="input-pass">
                </div>
            </div>   
            
             <div class="form-footer">                
                <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>            
            </div> 
            `;
    }

    protected getTemplateName(): string {
        return "candidate-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "w-form-small"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        let viewModel = {
            idCandidate: ko.observable("")
            ,
            firstName: ko.observable("")
            ,
            lastName: ko.observable("")
            ,
            fullName: ko.observable("")
            ,
            email: ko.observable("")
            ,
            password: ko.observable("")
            ,
            passwordConfirmation: ko.observable("")
            ,
            selectedRoles:ko.observable([20])
            ,
            selectedBrands:ko.observable([''])
            ,
            isActive:ko.observable(1)
            ,
            loginName:ko.observable("")
            ,
            countries: ko.observableArray([])
            ,
            idCountry: ko.observable(null)
            ,
            token:ko.observable("")
            ,
            selectedState: ko.observable(null),

            onClickSave: function (data, event) {
                huit_neuf_this.onClickSave();
            }
            ,
            onClickCancel: function (data, event) {
                huit_neuf_this.onClickCancel();
            },
            onChangeCountry: function (data, event) {
                huit_neuf_this.onChangeCountry(data);
            }

        };
        return viewModel;
    }

    protected initPartial(): void {
       
        this.countryGroups = new countryStates_template('countryGroups', this.getTemplateViewModel(), this.caller);

    }
    
    public onChangeCountry(data) {

        let idCountry = data.idCountry();
        this.countryGroups.setCountryAndState(idCountry, '');
    }

    protected onClickSave() {
        this.getTemplateViewModel().selectedState(this.countryGroups.getSelectedState());
        this.caller.saveCandidate()
    }

    protected onClickCancel() {

        this.caller.cancelCandidate();
    }

    public setCandidate(candidate){
        this.getTemplateViewModel().idCandidate(candidate.idCandidate);
        this.getTemplateViewModel().firstName(candidate.firstName);
        this.getTemplateViewModel().lastName(candidate.lastName);
        this.getTemplateViewModel().email(candidate.email);
        this.getTemplateViewModel().loginName(candidate.email);
        this.getTemplateViewModel().fullName(candidate.firstName+ ' ' + candidate.lastName);
        this.getTemplateViewModel().token(candidate.token);
        this.getTemplateViewModel().selectedBrands([candidate.brand])
    }

    public setCountries(countries){

        this.getTemplateViewModel().countries(countries);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/candidate_template.ts